// Vocabulary: readers see this feature as "owner reviews"; code, routes, DealHunt paths and
// analytics events keep the historical "owner note" name on purpose — do not rename them.

import clsx from 'clsx'
import styles from './HandoffHint.module.css'

/**
 * One Review Writer: the one muted line under (or beside) an ask that hands off to the community
 * writer — the CTA leaves the page, so it says what opens. The copy is `handoffHint(src, newTab)`
 * (`lib/community/writer-handoff.ts`); the reference strip folds it into its question body instead.
 */
const HandoffHint: React.VFC<{ text: string; className?: string }> = ({ text, className }) => (
  <p className={clsx(styles.hint, className)}>{text}</p>
)

export default HandoffHint
